import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Card } from "@pushpress/pushpress-ui";
import { useGetPeopleRecords } from "../api/hooks";
import { leadsColumns, membersColumns, staffColumns } from "./table/columns";
import AddPerson from "./shared/AddPerson";
import PeopleTable, { PersonRecord } from "./table/PeopleTable";
import { PEOPLE_TYPE, PeopleType } from "../types";
import useQuery from "../../../utils/query";
import EventInvitationBanner from "./shared/EventInvitationBanner";

export function PeopleManagement({ currentTab }: { currentTab: PeopleType }) {
  const history = useHistory();

  const [activeTab, setActiveTab] = useState<PeopleType>(currentTab);
  const { queryParams } = useQuery();

  const [selectedPeople, setSelectedPeople] = useState<PersonRecord[]>([]);

  const bannerType = queryParams.get("banner");
  const eventId = queryParams.get("event_id");

  const { data, isError, isFetching, refetch } =
    useGetPeopleRecords(currentTab);

  const handleTabChange = (value: string) => {
    setActiveTab(value as PeopleType);

    history.replace({
      pathname: `/people/${value}`,
      search: new URLSearchParams(history.location.search).toString(),
    });
  };

  const getColumn = (peopleType: PeopleType) => {
    if (peopleType === PEOPLE_TYPE.STAFF) {
      return staffColumns;
    }
    if (peopleType === PEOPLE_TYPE.LEADS) {
      return leadsColumns;
    }
    return membersColumns;
  };

  const showError = isError && !isFetching;

  return (
    <>
      <EventInvitationBanner
        show={bannerType === "event" && !!eventId}
        eventId={eventId}
        userUuids={selectedPeople?.map(({ userUuid }) => userUuid) || []}
      />
      <div className="tw-flex tw-flex-col tw-items-center tw-h-screen">
        <div className="tw-container tw-mx-auto tw-pb-8 tw-pt-2 tw-px-5">
          <AddPerson />
          <Card className="tw-overflow-hidden">
            <div className="tw-border-b tw-border-neutral-300">
              <PeopleTable
                activeTab={activeTab}
                columns={getColumn(activeTab)}
                data={data || []}
                handleTabChange={handleTabChange}
                onRowSelectionChange={setSelectedPeople}
                isError={showError}
                isLoading={isFetching}
                refetch={refetch}
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
